// CheckoutForm.tsx
import { queryClient } from '@/state/queryClient';
import { Text } from '@mantine/core';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { PrimaryButton } from './PrimaryButton';

export const CheckoutForm = ({ clientSecret }: { clientSecret: string }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [hasSucceeded, setHasSucceeded] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      return;
    }

    setLoading(true);

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    if (result.paymentIntent?.status === 'succeeded') {
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['caseState'] });
      }, 5000);
      setHasSucceeded(true);
    }

    setLoading(false);
  };

  if (hasSucceeded) {
    return (
      <Text
        size={16}
        align="left"
        c="primary.0"
        weight="bold"
        style={{
          margin: '4px auto 0 auto',
        }}
      >
        Payment succeeded!
      </Text>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div
        style={{
          padding: '12px 16px',
          borderRadius: '8px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
        }}
      >
        <CardElement
          options={{
            style: {
              base: {
                fontSize: '16px',
                color: '#1a1a1a',
                fontFamily: 'system-ui, sans-serif',
                '::placeholder': {
                  color: '#c0c4cc',
                },
                iconColor: '#999',
              },
              invalid: {
                color: '#e53935',
                iconColor: '#e53935',
              },
            },
          }}
        />
      </div>

      <PrimaryButton
        size="sm"
        type="submit"
        mt={20}
        isLoading={loading}
        align="start"
      >
        Submit
      </PrimaryButton>
    </form>
  );
};
